module.exports = __webpack_public_path__ + "static/media/ondemand.ad18d2a5.jpg";